import type { Operation } from 'oas/operation';

export const getOperationKey = (operation: Operation) => `${operation.path}-${operation.method}`;

export const sanitizeAnchorSegment = (value: string) =>
  value
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9-]+/g, '-')
    .replace(/^-+|-+$/g, '');

type AnchorPart = number | string | undefined;

export const buildAnchorId = (...parts: AnchorPart[]) => {
  const anchor = parts
    .map(part => {
      if (part === 0) return '0';
      if (!part) return '';
      return sanitizeAnchorSegment(String(part));
    })
    .filter(Boolean)
    .join('-');

  return anchor || undefined;
};
